export enum EPackType {
  HU = "HU",
  HOP = "HOP",
  KG = "KG",
  CAN = "CAN",
  CHAI = "CHAI",
  GOI = "GOI",
  PCE = "PCE",
  BAO = "BAO",
  XO = "XO",
  LT = "LT",
}
